/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-useless-constructor */
import { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import createIcon from '../../../../static/img/createIcon.svg';
import { API_URL } from '../../../../utils/constants';
import GridWrapper from '~/src/components/common/GridWrapper';

export default function ContainersList(): JSX.Element {
  const history = useHistory();
  const stateRef = useRef(null);
  const url = `${API_URL}/products/containers/get`;
  const StatefullGrid = withState(Grid, url);

  const productNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/containers/edit/${dataItem.id}`}>{dataItem?.name}</Link>
      </td>
    );
  };

  return (
    <WhitePad isFluid>
      <TitleComponent
        title="Containers"
        titleRight="Create"
        onRightHandler={(): void => history.push('/containers/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="length" title="Length (cm)" />
          <GridColumn field="name" title="Name" cell={(row) => productNameCell(row, stateRef)} />
          <GridColumn field="width" title="Width (cm)" />
          <GridColumn field="height" title="Height (cm)" />
          <GridColumn field="doorWidth" title="Door Width (cm)" />
          <GridColumn field="doorHeight" title="Door Height (cm)" />
          <GridColumn field="usableHeight" title="Usable Height (cm)" />
          <GridColumn field="maximumPayload" title="Maximum Payload (kg)" />
          <GridColumn field="averageTare" title="Container Weigth (kg)" />
          <GridColumn field="cubicCapacity" title="Cubic Capacity (m^2)" />
          <GridColumn field="pallets120X100" title="Capacity of 120x100" />
          <GridColumn field="pallets120X80" title="Capacity of 120x80" />
          <GridColumn field="palletsIso" title="Capacity of ISO" />
          <GridColumn field="pallets80X60" title="80x60" />
          <GridColumn field="pallets120X20" title="120x20" />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
